import React from 'react'

const Head_data = ({ data,size,font ,color}) => {
  return (
    <div className={`text-${size} md:font-${font} ${color}`} >
      {data}
    </div>
  )
}

export default Head_data
